// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__ZhtDh","image":"recipe_image__2-EDw"};